module.exports = __webpack_public_path__ + "static/media/down.dd735a3e.svg";